<!--- COMPONENTE PCMovimientosDeAlmacenPendientesDeSincronizar  ---->
<!---
Descripción del componente:
---------------------------
- Incluye una lista con los movimientos de almacen pendientes de sincronizar.

Eventos del componente:
-----------------------
-  xxxxxxxxxxx ->
--->
<template>
  <div class="div-componentePCMovimientosDeAlmacenPendientesDeSincronizar">
    <div class="data-table">
      <!-- Preloader de carga -->
      <UCPreload :show="mostrarPrecarga" />

      <template v-if="movimientosPendientes != null">
        <!-- No existen registros de movimientos pendientes -->
        <PCInformacionSinRegistros
          v-if="movimientosPendientes.length === 0"
          :titulo="$t('production.locations.pendingMovementsPopup.hasNoData.title')"
          subtitulo=""
        />

        <template v-else>
          <f7-block-title v-if="mostrarTitulo">
            {{ $t('production.locations.pendingMovementsPopup.hasData.blockTitle') }}
          </f7-block-title>

          <div
            v-if="movimientosPendientes != null && movimientosPendientes.length > 0"
            class="div-registroElementoLeido"
          >
            <f7-row
              v-for="(elementoPale, i) in movimientosPendientes"
              :key="i"
              class="row-elementoMover"
            >
              <f7-col width="85">
                <f7-row>
                  <f7-col width="50">
                    <span class="span-texto-gris-14-500">
                      {{ $t('common.pallet') }}
                    </span>
                  </f7-col>
                  <f7-col width="50">
                    <span class="span-texto-gris-14-500">
                      {{ $t('common.destination') }}
                    </span>
                  </f7-col>
                </f7-row>
                <f7-row>
                  <f7-col width="50">
                    <span
                      v-if="elementoPale.ElementoMover.CodigoBarrasPale"
                      class="span-texto-teal-18-800"
                    >
                      {{ elementoPale.ElementoMover.CodigoBarrasPale }}
                    </span>
                    <span
                      v-if="elementoPale.ElementoMover.NumeroSerie"
                      class="span-texto-teal-18-800"
                    >
                      {{ elementoPale.ElementoMover.NumeroSerie }}
                    </span>
                  </f7-col>
                  <f7-col width="50">
                    <span class="span-texto-amarillo-16-600"> {{ elementoPale.UbicacionDestino.Nombre }} </span>
                  </f7-col>
                </f7-row>
                <f7-row class="row-elementoMoverMensaje">
                  <f7-col
                    v-if="elementoPale.UltimoIntentoSincronizacion"
                    width="100"
                  >
                    <span class="span-texto-gris-16-800">
                      {{ `${FormatearFecha(elementoPale.UltimoIntentoSincronizacion.FechaEstado)} - ${FormatearHora(elementoPale.UltimoIntentoSincronizacion.FechaEstado)}` }}
                    </span>
                    <br>
                    <span class="span-texto-gris-16-500">
                      {{ elementoPale.UltimoIntentoSincronizacion.MensajeError }}
                    </span>
                  </f7-col>
                </f7-row>
              </f7-col>
              <f7-col
                class="display-flex justify-content-center"
                width="15"
              >
                <div
                  class="btn-base-rojo-1 selectable"
                  :title="$t('production.common.deletePendingMovement')"
                  @click="EliminarMovimientoPendiente(elementoPale)"
                >
                  <img
                    alt="iconDelete"
                    src="@/static/icons/ic_delete.svg"
                  >
                </div>
              </f7-col>
            </f7-row>
          </div>
        </template>
      </template>
    </div>

    <!-- Boton de Sincronización -->
    <div
      v-if="movimientosPendientes != null && movimientosPendientes.length > 0"
      class="div-opcionesFrm"
    >
      <f7-button
        fill
        class="btn-color-oscuro-1 btn-tamaño-3 btn-tamaño-3 btn-sincronizar"
        @click="SincronizarMovimientosPendientes()"
      >
        {{ $t('common.syncNow') }}
      </f7-button>
    </div>
  </div>
</template>

<script>
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import SoporteFechaYHora from '@/js/common/HIConversionSupport';
import {
  ProcesarResultadosCambiosDeUbicacion,
  guardarMovimientosDeAlmacenPendientes,
  obtenerMovimientosDeAlmacenPendientes,
} from '@/js/common/HiSynchronizationSupport';
import PCInformacionSinRegistros from '@/components/production/traceability/PCInformacionSinRegistros.vue';
import { HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import UCPreload from '@/components/common/UCPreload.vue';

export default {
  name: 'PCMovimientosDeAlmacenPendientesDeSincronizar',
  components: {
    PCInformacionSinRegistros,
    UCPreload,
  },
  props: {
    actualizar: { type: Number, default: null }, // Contine la ultima fecha de actualización, al cambiar se dispara la actualizacion de datos.
    activo: { type: Boolean, default: true },
    mostrarTitulo: { type: Boolean, default: false },
    sincronizarTodo: { type: Date, default: null }, // Cuando cambia su valor, lanza la soncronizacion de todo lo pendiente.
  },

  emits: ['MovimientosSincronizados'],

  data() {
    return {
      movimientosPendientes: null,
      mostrarPrecarga: false, // Controla si se muestra el componente de precarga.
    };
  },
  watch: {
    activo(val) {
      if (val) {
        this.InicializarComponente();
      } else {
        this.RestablecerComponente();
      }
    },
    actualizar(val) {
      if (val != null) {
        this.InicializarComponente();
      }
    },
    sincronizarTodo(val) {
      if (val != null) {
        this.SincronizarMovimientosPendientes();
      }
    },

  },
  created() {
    this.InicializarComponente();
  },

  methods: {
    InicializarComponente() {
      Log(this, this.InicializarComponente.name);
      this.movimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los pendientes del soporteSincronizacion
    },

    RestablecerComponente() {
      Log(this, this.RestablecerComponente.name);

      this.movimientosPendientes = null;
    },

    EliminarMovimientoPendiente(movimiento) {
      Log(this, this.EliminarMovimientoPendiente.name);

      const tempPos = this.movimientosPendientes.indexOf(movimiento);
      this.movimientosPendientes.splice(tempPos, 1);
      guardarMovimientosDeAlmacenPendientes(this.movimientosPendientes); // Actualizamos los elementos del soporteSincronización.
    },

    SincronizarMovimientosPendientes() {
      Log(this, this.SincronizarMovimientosPendientes.name);

      // Por si se llama este metodo  desde fuera sin Inicializar el componente volvemos a obtenerlas.
      this.movimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los pendientes del soporteSincronizacion
      const self = this;
      PreloaderGH(true, false);
      ConexionTA.callSincronizarMovimientosCambioUbicacion(JSON.stringify(this.movimientosPendientes)).then((result) => {
        if (result.Valor) {
          PreloaderGH(false);
          HiNotification.Toast(this.$t('production.locations.pendingMovementsPopup.sync.successToast.text'));
          guardarMovimientosDeAlmacenPendientes([]); // Todos se han realizado correctos los borramos
          self.movimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los pendientes del soporteSincronizacion
        } else {
          PreloaderGH(false);
          HiNotification.Alert(this.$t('production.locations.pendingMovementsPopup.sync.errorAlert.text'), this.$t('common.error'));
          const resultadoCambiosUbicacion = JSON.parse(result.Mensaje);
          self.ProcesarResultados(resultadoCambiosUbicacion);
        }
        self.$emit('MovimientosSincronizados');
      })
        .catch((error) => {
          PreloaderGH(false);
          HiNotification.Alert(this.$t('common.checkYourConnection'), this.$t('common.error'));
          LogError(error);
        });
    },

    ProcesarResultados(resultadoCambiosUbicacion) {
      Log(this, this.ProcesarResultados.name);

      ProcesarResultadosCambiosDeUbicacion(resultadoCambiosUbicacion); // Método del soporte Sincronización.
      this.movimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los movimientos.
    },

    FormatearFecha(fecha) {
      return SoporteFechaYHora.ObtenerDiaMesAno(fecha);
    },

    FormatearHora(fecha) {
      return SoporteFechaYHora.obtenerHorasYMinutos(fecha);
    },
  },
};
</script>

<style scoped>
.div-opcionesFrm {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-sincronizar {
  max-width: 330px;
  min-width: 275px;
}

.div-registroElementoLeido {
  flex-direction: column;
  margin: var(--f7-typography-margin);
}

.row-elementoMover {
  display: flex;
  align-items: center;
  padding: calc(var(--f7-typography-padding) / 2) var(--f7-typography-padding);
  border-bottom: 1px solid var(--his-disabled);
}

.row-elementoMoverMensaje {
  padding-top: 10px;
}
</style>
